import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadingStateService } from '../../tidy-ui-components/providers/loading-state/loading-state.service';

@Component({
  selector: 'app-component-showcase',
  templateUrl: './component-showcase.html',
  styleUrls: ['./component-showcase.scss'],
  standalone: false
})
export class ComponentShowcasePage implements OnInit {

  // Form controls for various components
  inputForm = new FormGroup({
    textInput: new FormControl('', [Validators.required]),
    emailInput: new FormControl('', [Validators.email]),
    phoneInput: new FormControl(''),
    currencyInput: new FormControl(''),
    passwordInput: new FormControl('')
  });

  selectForm = new FormGroup({
    singleSelect: new FormControl(''),
    multiSelect: new FormControl([])
  });

  checkboxForm = new FormGroup({
    checkbox1: new FormControl(false),
    checkbox2: new FormControl(true),
    checkbox3: new FormControl(false)
  });

  radioForm = new FormGroup({
    radioGroup: new FormControl('option1')
  });

  toggleForm = new FormGroup({
    toggle1: new FormControl(false),
    toggle2: new FormControl(true)
  });

  dateForm = new FormGroup({
    datePicker: new FormControl(''),
    dateRange: new FormControl({ start: '', end: '' })
  });

  textareaForm = new FormGroup({
    message: new FormControl('')
  });

  // Sample data for components
  selectOptions = [
    { value: 'option1', viewValue: 'Option 1' },
    { value: 'option2', viewValue: 'Option 2' },
    { value: 'option3', viewValue: 'Option 3' },
    { value: 'option4', viewValue: 'Option 4' },
    { value: 'option5', viewValue: 'Option 5' }
  ];

  autocompleteOptions = [
    { value: 'apple', viewValue: 'Apple' },
    { value: 'banana', viewValue: 'Banana' },
    { value: 'cherry', viewValue: 'Cherry' },
    { value: 'date', viewValue: 'Date' },
    { value: 'elderberry', viewValue: 'Elderberry' }
  ];

  tableData = [
    { id: 1, name: 'John Doe', email: 'john@example.com', status: 'Active' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', status: 'Inactive' },
    { id: 3, name: 'Bob Johnson', email: 'bob@example.com', status: 'Active' }
  ];

  stepperSteps = [
    { label: 'Step 1', description: 'Basic Information' },
    { label: 'Step 2', description: 'Contact Details' },
    { label: 'Step 3', description: 'Preferences' },
    { label: 'Step 4', description: 'Review & Submit' }
  ];

  carouselItems = [
    { title: 'Slide 1', content: 'This is the first slide content' },
    { title: 'Slide 2', content: 'This is the second slide content' },
    { title: 'Slide 3', content: 'This is the third slide content' }
  ];

  dragDropItems = [
    { id: 1, name: 'Item 1', description: 'First draggable item' },
    { id: 2, name: 'Item 2', description: 'Second draggable item' },
    { id: 3, name: 'Item 3', description: 'Third draggable item' }
  ];

  // Component states
  showModal = false;
  showFab = false;
  loading = false;
  currentStep = 0;

  constructor(public loadingState: LoadingStateService) {}

  ngOnInit() {
    // Initialize any required data
  }

  // Action methods for buttons and interactive components
  async handleButtonClick() {
    console.log('Button clicked!');
    this.loadingState.loading = true;
    setTimeout(() => {
      this.loadingState.loading = false;
    }, 2000);
  }

  async handleAsyncAction() {
    console.log('Async action started');
    this.loadingState.loading = true;
    await new Promise(resolve => setTimeout(resolve, 3000));
    this.loadingState.loading = false;
    console.log('Async action completed');
  }

  handleSelectChange(value: any) {
    console.log('Select changed:', value);
  }

  handleCheckboxChange(value: any) {
    console.log('Checkbox changed:', value);
  }

  handleRadioChange(value: any) {
    console.log('Radio changed:', value);
  }

  handleToggleChange(value: any) {
    console.log('Toggle changed:', value);
  }

  handleDateChange(value: any) {
    console.log('Date changed:', value);
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  toggleFab() {
    this.showFab = !this.showFab;
  }

  nextStep() {
    if (this.currentStep < this.stepperSteps.length - 1) {
      this.currentStep++;
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  handleFileUpload(files: FileList) {
    console.log('Files uploaded:', files);
  }

  handleDragDrop(event: any) {
    console.log('Drag drop event:', event);
  }

  // Sample error messages
  getErrorMessage(controlName: string): string {
    const control = this.inputForm.get(controlName);
    if (control?.hasError('required')) {
      return 'This field is required';
    }
    if (control?.hasError('email')) {
      return 'Please enter a valid email address';
    }
    return '';
  }
}
